(function (w) {
	w.MaxpayAnalytics = {
		trackForm: function (status, type) {
			if (typeof gtag === 'undefined') {
				console.error("gtag is not defined");
				return false;
			}

			// Validation
			const validTypes = ['home', 'gaming', 'dating', 'subscription', 'travel', 'start' ];
			const validStatuses = ['success', 'error'];

			if (!validTypes.includes(type)) {
				console.error(`Invalid type provided '${type}'`);
				return false;
			}

			if (!validStatuses.includes(status)) {
				console.error(`Invalid status provided '${status}'`);
				return false;
			}

			console.log({
				'formName': `${status}-${type}-formsend`,
				'formURL': location.href
			});

			gtag('event', 'formsend', {
				'formName': `${status}-${type}-formsend`,
				'formURL': location.href
			});

			return true;
		}
	}
})(window);
